import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import type { QualityThresholds } from './types';

const ThresholdBar: React.FC<{ thresholds: QualityThresholds }> = ({ thresholds }) => (
  <div className="flex items-center gap-1.5 text-[9px] text-zinc-500 mb-1 px-1">
    <SlidersHorizontal size={9} className="text-zinc-600" />
    <span className="font-medium text-zinc-400">门槛</span>
    <span className="font-mono">
      吞吐≥{thresholds.minThroughputKbps}k · 丢包&lt;{thresholds.maxLossPct}% · 抖动&lt;{thresholds.maxJitterMs}ms
    </span>
  </div>
);

export default ThresholdBar;
